module.exports = __webpack_public_path__ + "static/media/icon-calendar.40d59a03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-calendar.svg
// module id = ./src/assets/images/icon-calendar.svg
// module chunks = 6